import { HStack, Text } from '@chakra-ui/react'
import { useStore } from '@tanstack/react-store'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { userCardStore } from 'shared/store/userCard'
import {
  getDateReadFormat,
  getDateToSubmit,
  getDiffDateDays,
  getDiffDateHours,
} from 'shared/utils/dateFormatting'
import { getRangeDateFromType } from '../IncomingTransfers.utils'
import { Button, InputDate, Modal } from 'uikit'

export const RangeDateModal = ({ label }) => {
  const [isOpen, setIsOpen] = useState(false)
  const cancelRef = useRef()
  const [fromDateInput, setFromDateInput] = useState('')
  const [toDateInput, setToDateInput] = useState('')
  const { incomingTransfers } = useStore(userCardStore)
  const { fromDate, toDate } = incomingTransfers
  const isDisabledSubmit = fromDateInput === '' || toDateInput === ''
  const [errorMessage, setErrorMessage] = useState('')

  const onOpen = () => {
    setIsOpen(true)
  }

  useEffect(() => {
    setErrorMessage('')
    setFromDateInput(getDateReadFormat(fromDate))
    setToDateInput(getDateReadFormat(toDate))
  }, [fromDate, toDate])

  useEffect(() => {
    if (fromDateInput === '' || toDateInput === '') {
      return
    }
    const fromDateToSubmit = getDateToSubmit(fromDateInput)
    const toDateToSubmit = getDateToSubmit(toDateInput)
    const minDate = getDateToSubmit('01.01.2020')
    const currentDate = moment().set({ h: 0, m: 0, s: 0 })
    const checkFromDateMin = getDiffDateDays(fromDateToSubmit, minDate)
    const checkFromDateMax = getDiffDateHours(currentDate, fromDateToSubmit)
    const checkToDateMin = getDiffDateDays(toDateToSubmit, minDate)
    const checkToDateMax = getDiffDateHours(currentDate, toDateToSubmit)
    const startMoment = moment(fromDateToSubmit ? fromDateToSubmit : undefined).set({
      h: 0,
      m: 0,
      s: 0,
    })
    const endMoment = moment(toDateToSubmit ? toDateToSubmit : undefined).set({ h: 0, m: 0, s: 0 })
    const diffDate = startMoment.diff(endMoment, 'hours')
    if (checkFromDateMin < 0) {
      setErrorMessage('"Дата с" не должна быть меньше 01.01.2020')
      return
    }
    if (checkFromDateMax < 0) {
      setErrorMessage('"Дата с" не должна быть больше текущего дня')
      return
    }
    if (checkToDateMin < 0) {
      setErrorMessage('"Дата по" не должна быть меньше 01.01.2020')
      return
    }
    if (checkToDateMax < 0) {
      setErrorMessage('"Дата по" не должна быть больше текущего дня')
      return
    }
    if (diffDate > 0) {
      setErrorMessage('"Дата с" больше "Дата по"')
      return
    }
    setErrorMessage('')
  }, [fromDateInput, toDateInput])

  const onClose = () => setIsOpen(false)

  const handleSubmit = () => {
    userCardStore.setState((state) => {
      return {
        ...state,
        incomingTransfers: {
          ...state.incomingTransfers,
          fromDate: getDateToSubmit(fromDateInput),
          toDate: getDateToSubmit(toDateInput),
          dateRange: '',
        },
      }
    })
    onClose()
  }

  return (
    <>
      <Button size="sm" width="198px" onClick={onOpen}>
        {label}
      </Button>
      <Modal
        role="alertdialog"
        title="Выберите даты"
        isOpen={isOpen}
        onClose={onClose}
        leastDestructiveRef={cancelRef}
        footer={
          <>
            <Button onClick={onClose}>Отменить</Button>
            <Button
              //ref={cancelRef}
              colorPalette="orange"
              onClick={handleSubmit}
              ml={3}
              disabled={isDisabledSubmit || errorMessage}
            >
              Сохранить
            </Button>
          </>
        }
      >
        <HStack gap={3} mb={4}>
          <InputDate
            hideClearButton
            value={fromDateInput}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="fromDate"
            label="Дата c"
            placement="bottom"
            onChange={(e) => setFromDateInput(e)}
            withDialog
            placeholder="01.01.2020"
          />
          <InputDate
            hideClearButton
            value={toDateInput}
            dayPickerProps={{
              showCurrentDate: false,
            }}
            name="toDate"
            label="Дата по"
            placement="bottom"
            onChange={(e) => setToDateInput(e)}
            withDialog
            placeholder="01.01.2020"
          />
        </HStack>
        <Text fontSize="0.9rem" color="red.400">
          {errorMessage !== '' && errorMessage}
        </Text>
      </Modal>
    </>
  )
}
